const getMaximumQuantity = (hasAvailabilityInfo, quantityAvailable, maximum) =>
  hasAvailabilityInfo ? Math.min(Math.max(quantityAvailable, 1), maximum) : quantityAvailable || maximum

export default getMaximumQuantity
